<template>
  <Production-Foreman
    foreman-type="asphalt"
    :supplier="supplier"
    :mix-design="mixDesign"
  />
</template>
<script>
import ProductionForeman from './ProductionForeman.vue'

export default {
  components: {
    ProductionForeman,
  },
  props: {
    supplier: {
      type: String,
      default: '',
    },
    mixDesign: {
      type: String,
      default: '',
    },
  },
}
</script>
